import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ActivityService } from '../../../services/activity.service';
import { AuthService } from '../../../services/auth.service';
import { BeratungsprotokollService } from '../../../services/beratungsprotokoll.service';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FloatLabelModule } from 'primeng/floatlabel';
import { CalendarModule } from 'primeng/calendar';
import { user } from '../../../models/user.model';
import { UserService } from '../../../services/user.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { FileUploadModule } from 'primeng/fileupload';

import { Activity } from '../../../models/activity.model';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';

@Component({
  selector: 'app-create-beratungsprotokoll',
  standalone: true,
  templateUrl: './create-beratungsprotokoll-dialog.component.html',
  styleUrls: ['./create-beratungsprotokoll-dialog.component.scss'],
  providers: [MessageService, UserService],

  imports: [
    DropdownModule,
    DialogModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    CommonModule,
    InputTextModule,
    FloatLabelModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    InputNumberModule,
    FileUploadModule,
    CheckboxModule,
    InputSwitchModule,
  ],
})
export class CreateBeratungsprotokollComponent implements OnInit {
  @Input() dialogVisible: boolean = false;
  @Output() dialogVisibleChange = new EventEmitter<boolean>();

  protocolForm: FormGroup;
  users: user[] = [];
  selectedPdfFile: File | null = null;

  constructor(
    private fb: FormBuilder,
    private activityService: ActivityService,
    private authService: AuthService,
    private protokollService: BeratungsprotokollService,
    private messageService: MessageService
  ) {
    this.protocolForm = this.fb.group({
      userId: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers(): void {
    // Kişi listesini doldur (örneğin userService.getUserWithQuery gibi)
    // Burada sabit örnek dizi verelim:
    this.users = [
      { userId: 1, fullName: 'Ali Veli' },
      { userId: 2, fullName: 'Ayşe Fatma' },
      // ...
    ];
  }

  onFileSelected(event: any): void {
    if (event.files && event.files.length > 0) {
      this.selectedPdfFile = event.files[0];
      console.log('PDF seçildi:', this.selectedPdfFile.name);
    }
  }

  submitProtocol(): void {
    if (this.protocolForm.invalid || !this.selectedPdfFile) return;

    const formValue = this.protocolForm.value;
    const newProtokoll = {
      userId: formValue.userId,
      creatorId: this.authService.getCurrentUserId(),
    };

    // <-- Service metodu 'createProtokoll' ise burada da aynı yaz:
    this.protokollService.createProtokoll(newProtokoll).subscribe({
      next: (createdRecord) => {
        this.protokollService
          .uploadProtokollPdf(createdRecord.id, this.selectedPdfFile!)
          .subscribe({
            next: (pdfUrl) => {
              createdRecord.pdfUrl = pdfUrl;
              this.updateProtokoll(createdRecord);
              // ...
            },
            error: (err) => {
              console.error('Fehler beim PDF Upload:', err);
              // ...
            },
          });
      },
      error: (err) => {
        console.error('Fehler beim Erstellen des Protokolls:', err);
        // ...
      },
    });
  }

  updateProtokoll(protocol: any): void {
    // Yine service metodu 'updateProtokoll' ise aynı isim:
    this.protokollService.updateProtokoll(protocol).subscribe({
      next: () => console.log('Protokoll wurde aktualisiert.'),
      error: (err) => console.error('Fehler beim Update:', err),
    });
  }

  closeDialog(): void {
    this.dialogVisible = false;
    this.protocolForm.reset();
    this.selectedPdfFile = null;
    this.dialogVisibleChange.emit(this.dialogVisible);
  }
}
